import { render, staticRenderFns } from "./checkboxMedItem.vue?vue&type=template&id=5ddfb6e7&scoped=true"
import script from "./checkboxMedItem.vue?vue&type=script&lang=js"
export * from "./checkboxMedItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddfb6e7",
  null
  
)

export default component.exports